import {
    Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output,
    ViewChild
} from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { ConfigService } from "../../../../services/configService";
import { OrderService } from "../../../../services/orderService";
import { OrderContentService } from "../../../../services/orderContentService";
import { OrderContent } from "../../../../objects/orders/orderContent";
import { OrderDataType } from "../../../../objects/orders/orderDataType";
import { OrderContentData } from "../../../../objects/orders/orderContentData";
import { ActivatedRoute } from "@angular/router";
import { EmailService } from "../../../../services/emailService";
import { EmailTemplateType } from "../../../../objects/email/emailTemplateType";
import { ToastsManager } from "ng2-toastr";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { EmailRequest } from "../../../../objects/email/EmailRequest";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { CBP7501 } from "../../../../objects/documents/CBP7501";

/**
 * Created by alex.y on 9/29/2017.
 */

@Component({
    selector: 'order-data',
    templateUrl: 'orderData.component.html',
    moduleId: module.id.toString()
})
export class OrderDataComponent implements OnInit, OnChanges {
    @Input()
    public order: Order;

    @Output()
    public orderChange: EventEmitter<Order> = new EventEmitter();

    @Output()
    public tabChanged: EventEmitter<number> = new EventEmitter();

    public tabNumber: OrderStatus;

    public orderStatus = OrderStatus;

    public isProcessing: boolean = false;

    public orderContentComment: OrderContent = new OrderContent();

    private dataList: Array<OrderContent> = [];
    private paypalDisabled: boolean;
    public documents3461: Array<CBP3461> = [];
    public documents7501: Array<CBP7501> = [];

    constructor(public toastr: ToastsManager, private orderService: OrderService, public configService: ConfigService,
                public orderContentService: OrderContentService, private emailService: EmailService,
                private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        //this.documents3461 = this.route.snapshot.data.documents3461.Data;
        //this.documents7501 = this.route.snapshot.data.documents7501.Data;

        this.tabNumber = this.order.Status;

        /*because when order has been updated on order details,
         * tab number has been inited as OrderStatus.Calculated*/
        // if(this.order.Status == OrderStatus.Calculated)
        //     this.tabNumber = OrderStatus.Quoted;

        if (this.order.Status >= OrderStatus.BorderCrossed)
            this.tabNumber = OrderStatus.CustomReleased;

        this.isProcessing = true;
        this.paypalDisabled = false;
        this.getOrderContent();
    }

    private async getOrderContent(): Promise<void> {
        if (!this.order || !this.order.Id)
            return null;

        try {
            let response = await this.orderContentService.getByOrderIdAndStatus(this.order.Id, null);

            this.isProcessing = false;

            if (!response.Data)
                return;

            this.order.DataList = response.Data;

            this.dataList = response.Data;

            this.getCurrentComment();
        }
        catch (e) {
            console.log(e);
        }

    }

    public ngOnChanges(): void {
        if (this.order.DataList.length != 0 || this.dataList.length == 0)
            return;

        if (this.order.Id == this.dataList[0].OrderId)
            this.order.DataList = this.dataList;
        else
            this.getOrderContent();
    }

    public async createOrder(isOpenPayPal: boolean = false): Promise<void> {
        const googleWindow = window.open(`${window.location.origin}/paymentredirect`);

        try {
            this.paypalDisabled = true;
            let response = await this.orderService.createInvoice(this.order.Id);

            if (isOpenPayPal && response.Data) {
                googleWindow.location.replace(`${this.configService.config.PayPalUrl}/invoice/payerView/details/${response.Data.Invoice.Id}`);
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            this.paypalDisabled = false;
        }
    }

    public selectTab(tabNumber: number): void {
        if (tabNumber > this.order.Status)
            return;

        this.tabNumber = tabNumber;
        this.tabChanged.emit(this.tabNumber);

        if (tabNumber >= OrderStatus.BorderCrossed)
            this.tabNumber = OrderStatus.CustomReleased;

        this.getCurrentComment();

    }

    private getCurrentComment(): void {
        this.orderContentComment = this.order.DataList.find(x => x.OrderStatus == this.tabNumber && x.Data.Type == OrderDataType.Comment);

        if (this.orderContentComment == null) {
            this.orderContentComment = new OrderContent({
                OrderId: this.order.Id,
                OrderStatus: this.order.Status,
                Data: new OrderContentData({
                    Data: '',
                    Type: OrderDataType.Comment
                })
            });
            this.order.DataList.push(this.orderContentComment);
        }
    }

    public completeOrder(): void {
        if (this.order.Status == OrderStatus.Paid)
            this.order.Status = this.order.Status + 2;
        else
            this.order.Status = this.order.Status + 1;

        let doc = this.order.DataList;

        this.orderService.modify(this.order).then(x => {
            if (!x.Data)
                return;

            this.order = x.Data;
            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
            this.orderChange.emit(this.order);

            document.getElementById('mainPanel').scrollTop = 0;

            this.order.DataList = doc;
            this.selectTab(this.order.Status);
        })
    }

    public sendToCustomer(): void {
        this.emailService.sendOrderToCustomer(new EmailRequest({OrderId:this.order.Id, EmailType:EmailTemplateType.OrderToCustomerPay})).then(x => {
            this.toastr.success("Sending mail succeeded");
        }).catch(() => {
            this.toastr.error("Sending mail failed");
        });
    }

}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/orderData.component.ts